const platformNames = {
  YouTube: "YouTube",
  Facebook: "Facebook",
  Instagram: "Instagram",
  Bilibili: "Bilibili",
  TikTok: "TikTok",
  "Snapchat Stars": "Snapchat Stars",
};

export const boostContractContent = {
  header: {
    title: "ENFINITY LIMITED – ENFINIBOOST TERMS OF SERVICE",
    logo: "boost",
  },
  boostRightsBlock: {
    title: "EnfiniBoost rights also granted?",
    valuePath: "true",
  },
  signatureBlock: {
    serviceName: 'EnfiniCore ("On behalf of Enfinity Limited")',
    postAcquiredConsent: {
      title: "Exclusive EnfiniBoost rights also granted:",
      valuePath: "user.videos_protection_consent",
    },
    extraParagraphs: [
      {
        text: "The Content Submitted by the Producer for exclusive MSN rights to Enfinity Limited (and its authorized technology partners, including but not limited to: CreatorShield, Enfinity) was originally found at:",
        fontSize: 13,
        x: 15,
        fontWeight: "normal",
        maxWidth: 180,
      },
    ],
    bulletList: {
      path: "user.user_socials",
      keysOrder: ["youtube", "tiktok", "instagram", "facebook", "twitch", "douyin", "kuaishou", "rumble", "others"],
      x: 30,
      lineGap: 8,
    },
    optInPage: {
      title: "Opted-in for distribution on:",
      path: "user.optIn",
      filter: (key, value) => key !== "MSN Distribution" && value,
      labelMap: platformNames,
    },
  },
  paragraphs: [
    {
      text: "Herein referred to as the (\"Agreement\"), which is by and between Enfinity Limited, located at UNITS 1607-8, 16/F CITICORP CENTRE 18 WHITFIELD ROAD CAUSEWAY BAY HONG KONG, HONG KONG, HONG KONG, 000000, Hong Kong SAR (\"Enfinity Limited\", \"we\", \"us\"), and the undersigned producer/content owner (\"Producer\", \"you\", \"your\"), {{user.first_name}} {{user.last_name}}, who is registering to the service and has agreed to the terms of this User Agreement, effective as of today's date {{currentDate}}. This is the effective date {{currentDate}}.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    { text: "1. Scope", fontSize: 13, x: 15, fontWeight: "bold", maxWidth: 180 },
    {
      text: "1. The purpose of this Agreement is to grant Content Licensing rights to Enfinity Limited in order to legally perform its services and comply with the policies in place that moderate Enfinity Limited and its use of sensitive third-party tools, including but not limited to: Third-party ad-feeds and copyright royalty generation software that the Company uses in-house or contracts out to its network of technology partners, advertisers, and brands – with the ultimate goal of generating new revenue royalties for you.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. You still retain ownership of all your content, videos, and intellectual property.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. By agreeing to the terms set forth, you are allowing Enfinity Limited to generate new ad-feeds, including direct and embedded watch, on its various multimedia platform(s).",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. Content for Licensing",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "1. The \"Content\" means the content produced and posted to your social media channels that are being submitted upon registration and submission (examples include but are not limited to: YouTube, Instagram, TikTok, Facebook, Douyin, Kuaishou, etc.), as well as any other content that we and you agree in writing to include in this Agreement from time to time.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. You may deliver additional content to your point person at Enfinity Limited, or by writing to copyright@enfinity.com and attaching the content you desire to submit as a file or via cloud storage with your provider of choice, e.g. DropBox, OneDrive, etc.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. At the time of this Agreement, the social video content that you provided upon registration has been submitted by you to Enfinity Limited for its services to be performed. Not all content may be eligible, and Enfinity Limited's team will review the submitted content herein to ensure third-party platform compliance.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. Fees and Payments",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "1. Enfinity Limited will automatically split the revenue with the Producer in accordance with the revenue-sharing rates of this agreement. The arrangement for Ad-feed royalties (external to YouTube Monetization) shall be shared fifty percent to you and fifty percent to us. Along with this, five percent of the revenues generated will be deducted as a content hosting fee (at the moment, Dropbox Premium). Plus, an additional five percent to you (which is separate from the existing Ad-feed share) for any applicable algorithmic copyright claiming royalties, only if you opted in to this service upon registration.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. Payments are sent out within 30-days of revenue generation and payment made to us. For example, if you generate revenue in January, you will receive your share at the end of February.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. You will be responsible for taxes and reporting your revenues in your own respective country, and Enfinity Limited or any of its associates will not be held liable in any way in the event you neglect your duties to report whatever ought to be reported.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "4. Enfinity Limited will have no obligation to pay any amounts, and is permitted to deduct or withhold any amounts owed, determined or reasonably suspected by Enfinity Limited, in its sole discretion, to have resulted from:",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "(a) Action Fraud, including without limitation through any clicks originating from Producer's IP addresses or computers under Producer's control, solicited by payment of money, false representation or request for end users to click on Ads, or",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "(b) fraudulent, misleading or false activities or activities that Enfinity Limited believes to be fraudulent or misleading or in violation of either of their respective terms of service, guidelines, rules, or privacy policies.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "Enfinity Limited reserves the right to withhold or deduct any payments, pending Enfinity Limited's reasonable investigation of any of the foregoing or any breach of this Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "4. Contract Period",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "1. The period of this Agreement will be for 30-days with automatic renewals thereafter, unless you terminate this Agreement with 30-days written notice prior to the renewal date in the form of legal writing to copyright@enfinity.com.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. Should you decide to end this Agreement, we agree to stop pushing your new content into any new Ad-feed after the termination date passes. You acknowledge and understand that previously initiated content that had Ad-feeds will remain active and our license in effect. This also applies for Content ID claiming ONLY IF you checked the box upon registration to enroll into our Content ID service.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. If you choose to terminate this Agreement, we will ensure your final payment is processed within 30 days of termination. By ending your Agreement with Enfinity Limited or any of our affiliates, you agree that no further payments will be made to you after the termination date.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "5. Enfinity Limited's Rights and Licenses",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "You hereby grant to each of the following exclusive and non-transferable rights:",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "1. The legal right and license to use, reproduce, digitize, encode, modify, monetize, re-format, transmit, re-broadcast, repurpose the Content you submitted upon registration and collect revenues from the promotion, protection, publishing, and management of the Content on our multimedia platform.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. The exclusive right and license to administer content monetization services for the Content submitted to us across various digital media platforms. You agree that we withhold the right to not perform this service at any time.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. The ability to sub-license the content internally or externally to third-party ad-feed partners for the purpose of revenue generation from your content.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "4. [ONLY APPLIES IF YOU OPTED IN TO CONTENT ID CLAIMING] The exclusive, non-transferable right to administer copyright claims on your behalf on popular multimedia platforms, including YouTube's Content ID system.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "5. [ONLY APPLIES IF YOU OPTED IN TO CONTENT ID CLAIMING] The ability to create an anchor account, or first account, on platforms where your presence is not currently established in order to prevent pirates from wrongfully uploading your catalog and claiming first rights. The revenue share for this is outlined as a promotional royalty in section 3.1. Royalties will continue to be paid to us from anchor accounts post-termination, and a buyout offer will be made to you for sole ownership, typically at a multiple of twelve the gross ARR we have generated on your behalf.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "6. Ownership/Clearances/Warranties",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "1. You retain full ownership of your Content.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. You must have all the necessary rights and clearances in connection with the Content, and you have the legal right to grant the rights to us. By registering, digitally signing, and submitting your Content and rights to Enfinity Limited, you hereby absorb all legal liability in the event of legal proceedings relating to the Content you submitted for management.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. You warrant and represent that the Content does not infringe on the rights of any third party or violate third-party platforms. Additionally, you agree to defend, indemnify and hold harmless Enfinity Limited for any and all claims to the contrary.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "7. Other Provisions",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 180,
    },
    {
      text: "1. You agree to keep the terms of this Agreement confidential.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "2. This Agreement is governed and construed according to Hong Kong law, and by signing, you are agreeing to submit to the jurisdiction of Hong Kong.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "3. You and Enfinity Limited waive all rights to a jury trial, instead electing that the dispute be resolved by a judge. Additionally, both parties agree that any and all disputes or claims that have arisen or may arise between either parties (Enfinity Limited and You, the \"Producer\"), including federal and state, common law claims, and those based in contract, tort, fraud, misrepresentation or any other equitable or legal theory, and relating in any way to this website, its services or these will be resolved only by and through confidential final and binding arbitration, rather than in any court, except that You may only assert claims in small claims court if Your claims qualify and so long as the matter remains in such court and advances only on an individual (non-class, non-representative) basis.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "4. Upon submission of acceptance of this User Agreement, I agree that all information in this form is true and accurate. I also agree that if I am under 18, my parent/guardian will sign this User Agreement and absorb all legal liability for this User Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "5. You agree to, and are hereby bound to, our Terms of Service, found here, which may be amended from time to time. Fee and payment arrangements may also be amended from time-to-time. Continued use of our service is constituted as acceptance to such amendments. These terms include the exclusive, explicit, nontransferable content licensing rights to the content contractually submitted by you to Enfinity Limited. These rights remain even if you terminate this Agreement, in accordance with section 4 of this Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "6. Electronic communication is a sufficient method to notify a party.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "7. By signing, you agree as follows: 'I understand I am granting a non-transferable, irrevocable, fully exclusive license to all of the content submitted on the social media pages I am submitting, and that Enfinity Limited (and any other of its authorized divisions without limitation) may represent, sublicense and manage this content on my behalf without limitation.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
    {
      text: "[ATTACHED UPON SIGNING AT https://enfiniboost.com/esign]",
      fontSize: 12,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
      highlight: true,
      align: "center",
    },
    { spacing: 12 },
    {
      text: "The Content submitted by the Producer for exclusive ad-feed rights to Enfinity Limited, through its service known as Enfiniboost (and its authorized technology partners, including but not limited to: EnfiniShield), was originally found on the links provided upon registration by the user.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 180,
    },
  ],
};
